module.exports = __webpack_public_path__ + "media/apps/badges-play-store-5b63b8c0.svg";